<script>
import PhiSliderPanel from '../../Slider/Panel2.vue';
import PhiPersonAvatar from '@/components/Phi/Person/Avatar.vue';
import PhidiasTextUtils from "../../../../libraries/phidias.js/lib/Text.js";

export default {
    name: "phi-person-relevance-picker",
    components: {PhiSliderPanel, PhiPersonAvatar},

	model: {
		prop: 'selection'
	},

    props: {
        api: {
			required: true
		},

        personId: {
			type: String,
			required: true
		},

		selection: {
			type: Array,
			required: true,
			default: []
		}
    },

    data() {
        return {
            groups: [],
            activeGroup: null,

            template: {
                panelIsOpen: false,
                boxIsFlipped: false
            },

            peopleQuery: '',
            peopleFound: [],
            groupsFound: [],
            searchCache: {
                people: [],
                groups: []
            },
            searchTimeout: null,

            completedRequest: false,
            reuqestProgress: 0,
            partials: {
                relatives: [],
                sections: [],
                agroups: [],
                egroups: []
            },

            navigationGuard: null
        }
    },

    computed: {
        orderedPeopleFound: function () {
            this.peopleFound.sort((a, b) => {
                return b.matches.length - a.matches.length;
            });

            return this.peopleFound;
        },

        orderedGroupsFound: function () {
            this.groupsFound.sort((a, b) => {
                return b.matches.length - a.matches.length;
            });

            return this.groupsFound;
        },

        reverseSelection() {
            return this.selection.slice().reverse();
        }
    },

    watch: {
        peopleQuery: function(val) {
            if(val.length == 0){
                this.peopleFound = [];
            }
        }
    },

    methods: {
        createSearchCache(){
            let plain   = [];
            let groups  = [];

            this.groups.forEach(group => {

                let cachedGroup = groups.find(cache => cache.id === group.id);
                if(cachedGroup === undefined){
                    let miniGrp = {
                        id: group.id,
                        name: group.name,
                        filteredName: PhidiasTextUtils.removeDiacritics(group.name.trim().toLowerCase()),
                        type: group.type
                    };

                    groups.push(miniGrp);
                }


                if(group.hasOwnProperty("people")){
                    group.people.forEach(person => {
                        let cachedPerson = plain.find(cache => cache.id === person.id);

                        if(cachedPerson === undefined){
                            let mini = {
                                id: person.id,
                                firstname: person.firstname,
                                lastname: person.lastname,
                                filteredFirstname: PhidiasTextUtils.removeDiacritics(person.firstname.trim().toLowerCase()),
                                filteredLastname: PhidiasTextUtils.removeDiacritics(person.lastname.trim().toLowerCase()),
                                gender: person.gender,
                                avatar: person.avatar,
                                roles: person.roles,
                                groups: []
                            };
                            mini.groups.push(group.id);

                            plain.push(mini);
                        }else{
                            if(cachedPerson.groups.indexOf(group.id) < 0){
                                cachedPerson.groups.push(group.id);
                            }

                            if(person.hasOwnProperty("roles")){
                                person.roles.forEach(role => {
                                    if(cachedPerson.roles.indexOf(role) < 0){
                                        cachedPerson.roles.push(role);
                                    }
                                });
                            }
                        }

                    });
                }

                if(group.hasOwnProperty("members")){
                    group.members.forEach(person => {
                        let cachedPerson = plain.find(cache => cache.id === person.id);

                        if(cachedPerson === undefined){
                            let mini = {
                                id: person.id,
                                firstname: person.firstname,
                                lastname: person.lastname,
                                filteredFirstname: PhidiasTextUtils.removeDiacritics(person.firstname.trim().toLowerCase()),
                                filteredLastname: PhidiasTextUtils.removeDiacritics(person.lastname.trim().toLowerCase()),
                                gender: person.gender,
                                avatar: person.avatar,
                                roles: person.roles,
                                readonly: person.readonly ? person.readonly : false,
                                groups: []
                            };

                            mini.groups.push(group.id);
                            plain.push(mini);
                        }else{
                            if(cachedPerson.groups.indexOf(group.id) < 0){
                                cachedPerson.groups.push(group.id);
                            }

                            if(person.hasOwnProperty("roles")){
                                person.roles.forEach(role => {
                                    if(cachedPerson.roles.indexOf(role) < 0){
                                        cachedPerson.roles.push(role);
                                    }
                                });
                            }
                        }

                        if(person.hasOwnProperty("relatives")){
                            person.relatives.forEach(relative => {
                                let cachedRelative = plain.find(cache => cache.id === relative.id);

                                if(cachedRelative === undefined){
                                    let miniRelative = {
                                        id: relative.id,
                                        firstname: relative.firstname,
                                        lastname: relative.lastname,
                                        filteredFirstname: PhidiasTextUtils.removeDiacritics(relative.firstname.trim().toLowerCase()),
                                        filteredLastname: PhidiasTextUtils.removeDiacritics(relative.lastname.trim().toLowerCase()),
                                        gender: relative.gender,
                                        avatar: relative.avatar,
                                        roles: relative.roles,
                                        readonly: relative.readonly ? relative.readonly : false,
                                        groups: []
                                    };
                                    miniRelative.groups.push(group.id);

                                    plain.push(miniRelative);
                                }else{
                                    if(cachedRelative.groups.indexOf(group.id) < 0){
                                        cachedRelative.groups.push(group.id);
                                    }

                                    if(relative.hasOwnProperty("roles")){
                                        relative.roles.forEach(role => {
                                            if(cachedRelative.roles.indexOf(role) < 0){
                                                cachedRelative.roles.push(role);
                                            }
                                        });
                                    }
                                }
                            });
                        }
                    });
                }

            });

            this.searchCache.people = plain;
            this.searchCache.groups = groups;
        },

        //d is for debounced
        dSearch(){
            clearTimeout(this.searchTimeout);
			this.searchTimeout = setTimeout(this.search, 250);
        },

        search(){
            this.findPeople();
            this.findGroups();
        },

        clearSearch(){
            this.peopleQuery = '';
            this.peopleFound = [];
            this.groupsFound = [];
        },

        findPeople() {
            let trmQuery = this.peopleQuery.trim();
            this.peopleFound = [];

            if (trmQuery.length > 0) {
                trmQuery = PhidiasTextUtils.removeDiacritics(trmQuery.toLowerCase());

                this.searchCache.people.forEach(person => {
                    if(this.activeGroup !== null && person.groups.indexOf(this.activeGroup.id) < 0){
                        return;
                    }

                    if(!this.peopleFound.some(foundPerson => foundPerson.id == person.id)){
                        let matches = this.personInQuery(person, trmQuery);
                        if(matches.length > 0){
                            person.matches = matches;
                            this.peopleFound.push(person);
                        }
                    }

                });
            }
        },

        findGroups() {
            let trmQuery = this.peopleQuery.trim();
            this.groupsFound = [];

            if (trmQuery.length > 0) {
                trmQuery = PhidiasTextUtils.removeDiacritics(trmQuery.toLowerCase());

                if(this.activeGroup === null){
                    this.searchCache.groups.forEach(group => {
                        let matches = this.groupInQuery(group, trmQuery);
                        if(matches.length > 0){
                            group.matches = matches;
                            this.groupsFound.push(group);
                        }
                    });
                }
            }
        },

        isSelected(person) {
            return this.selection.some(selectedPerson => selectedPerson.id == person.id);
        },

        togglePerson(person) {
            this.isSelected(person) ? this.deselectPerson(person) : this.selectPerson(person);
        },

        selectPerson(person) {
            if (this.isSelected(person)) {
                return;
            }

            let selectable = true;
            if(person.hasOwnProperty("readonly")){
                if(person.readonly === true){
                    selectable = false;
                }
            }
            if(selectable){
                this.selection.push(person);
            }
        },

        deselectPerson(person) {
            for (var i = 0; i < this.selection.length; i++) {
                if (this.selection[i].id == person.id) {
                    this.selection.splice(i, 1);
                    return;
                }
            }
        },

        openGroup(group) {
            if(this.groupHasMembers(group)){
                this.clearSearch();
                this.activeGroup = this.groups.find(mainGrp => mainGrp.id === group.id);
                this.template.boxIsFlipped = true;
            }
        },

        closeGroup() {
            this.clearSearch();
            this.template.boxIsFlipped = false;
            this.activeGroup      = null;
        },

        groupHasMembers(group) {
            let equals = 0;

            if(group.hasOwnProperty("members")){
                if(group.members.length == group.people.length){
                    for(let i = 0; i < group.people.length; i++){
                        if(group.people[i].id == group.members[i].id){
                            equals += 1;
                        }
                    }
                }
            }

            if(equals > 0 && equals == group.people.length){
                return false;
            }else{
                return true;
            }
        },

        distinctRoles(group) {
            if (!group.hasOwnProperty('members')) {
                return [];
            }

            var retval = [];
            group.members.forEach(member => {

                if (member.roles && member.roles.length) {
                    member.roles.forEach(role => {
                        if (retval.indexOf(role) == -1) {
                            retval.push(role);
                        }
                    });
                }

                if (member.hasOwnProperty('relatives')) {
                    member.relatives.forEach(relative => {
                        if (relative.roles && relative.roles.length) {
                            relative.roles.forEach(relativeRole => {
                                if (retval.indexOf(relativeRole) == -1) {
                                    retval.push(relativeRole);
                                }
                            });
                        }
                    });
                }
            });

            return retval;
        },

        getRelatives(people){
            let relatives = [];
            people.forEach( person => {
                if (person.hasOwnProperty('relatives')) {
                    relatives = relatives.concat(person.relatives);
                }
            });
            return relatives;
        },

        roleIsSelected(people, role) {
            return people
                .filter(person => person.roles.indexOf(role) >= 0)
                .concat(this.getRelatives(people)
                    .filter(relative => relative.roles.indexOf(role) >= 0)
                )
                .every(this.isSelected);
        },

        selectWithRole(people, role) {
            people.forEach(person => {
                if (person.roles.indexOf(role) >= 0) {
                    this.selectPerson(person);
                }

                if (person.hasOwnProperty('relatives')) {
                    person.relatives.forEach(relative => {
                        if (relative.roles.indexOf(role) >= 0) {
                            this.selectPerson(relative);
                        }
                    });
                }
            });
        },

        deselectWithRole(people, role) {
            people.forEach(person => {
                if (person.roles.indexOf(role) >= 0) {
                    this.deselectPerson(person);
                }

                if (person.hasOwnProperty('relatives')) {
                    person.relatives.forEach(relative => {
                        if (relative.roles.indexOf(role) >= 0) {
                            this.deselectPerson(relative);
                        }
                    });
                }
            });
        },

        toggleWithRole(people, role) {
            this.roleIsSelected(people, role) ? this.deselectWithRole(people, role) : this.selectWithRole(people, role);
        },

        togglePicker() {
            if(!this.completedRequest){
                this.startRequest();
                this.template.panelIsOpen = true;
            }else{
                this.template.panelIsOpen = !this.template.panelIsOpen
            }
        },

        startRequest(){
            this.reuqestProgress += 5;
            let relatives = this.fetchRelatives().then(() => {
                this.reuqestProgress += 10;
                this.groups = this.getFullArray();
            });

            this.reuqestProgress += 5;
            let sections = this.fetchSections().then(() => {
                this.reuqestProgress += 20;
                this.groups = this.getFullArray();
            });

            this.reuqestProgress += 5;
            let agroups = this.fetchAcademicGroups().then(() => {
                this.reuqestProgress += 25;
                this.groups = this.getFullArray();
            });

            this.reuqestProgress += 5;
            let egroups = this.fetchEmployeeGroups().then(() => {
                this.reuqestProgress += 25;
                this.groups = this.getFullArray();
            });

            Promise.all([relatives, sections, agroups, egroups]).then( () => {
                this.createSearchCache();
                this.completedRequest = true;

                //lets free some memory
                this.partials.relatives = [];
                this.partials.sections = [];
                this.partials.agroups = [];
                this.partials.egroups = [];
            });
        },

        getFullArray(){
            return []
                    .concat(this.partials.relatives)
                    .concat(this.partials.sections)
                    .concat(this.partials.agroups)
                    .concat(this.partials.egroups);
        },

        fetchRelatives() {
            return this.api
                .get(`v3/people/${this.personId}/relevance/relatives`)
                .then(groups => {
                    this.partials.relatives = groups;
                });
        },

        fetchSections() {
            return this.api
                .get(`v3/people/${this.personId}/relevance/sections`)
                .then(groups => {
                    this.partials.sections = groups;
                });
        },

        fetchAcademicGroups() {
            return this.api
                .get(`v3/people/${this.personId}/relevance/academicgroups`)
                .then(groups => {
                    this.partials.agroups = groups;
                });
        },

        fetchEmployeeGroups() {
            return this.api
                .get(`v3/people/${this.personId}/relevance/employeegroups`)
                .then(groups => {
                    this.partials.egroups = groups;
                });
        },

        personInQuery(person, query){

            let words = query.split(" ");
            let matches = [];

            words.forEach(word => {
                if(this.txtInTxt(person.filteredFirstname, word) || this.txtInTxt(person.filteredLastname, word)){
                    matches.push(word);
                }
            });

            return matches;
        },

        groupInQuery(group, query){

            let words = query.split(" ");
            let matches = [];

            words.forEach(word => {
                if(this.txtInTxt(group.filteredName, word)){
                    matches.push(word);
                }
            });

            return matches;
        },

        txtInTxt(subject, query) {
            return subject.includes(query) ? true : false;
        },

        getPersonFullName(person){
            let fullName = "";

            if(person.hasOwnProperty("firstName") && person.firstName){
                fullName = fullName.concat(person.firstName);

                if(person.hasOwnProperty("lastName") && person.lastName){
                    fullName = fullName.concat(" ").concat(person.lastName);
                }

                if(person.hasOwnProperty("lastName2") && person.lastName2){
                    fullName = fullName.concat(" ").concat(person.lastName2);
                }
            }

            if(person.hasOwnProperty("firstname") && person.firstname){
                fullName = fullName.concat(person.firstname);

                if(person.hasOwnProperty("lastname") && person.lastname){
                    fullName = fullName.concat(" ").concat(person.lastname);
                }

                if(person.hasOwnProperty("lastname2") && person.lastname2){
                    fullName = fullName.concat(" ").concat(person.lastname2);
                }
            }

            if(fullName.length <= 0){
                fullName = "?"
            }

            return fullName;
        }
    },

    mounted() {
        this.navigationGuard = this.$router.beforeEach((to, from, next) => {

            if (!this.template.panelIsOpen) {
                next();
                return;
            }

            if (this.template.boxIsFlipped) {
                this.closeGroup();
                next(false);
                return;
            }

            if (this.template.panelIsOpen) {
                this.template.panelIsOpen = false;
                next(false);
                return;
            }
        });
    },

    beforeDestroy() {
        if (!this.navigationGuard) {
            return;
        }

        this.navigationGuard();
    }
}
</script>

<template>
    <div class="phi-person-relevance-picker">

        <div @click="togglePicker">

            <slot>
                <!-- default content: a list of chips -->
                <div class="people-list">
                    <slot name="label">
                        <span>{{ $t('notice.ToNPeople', {n: selection.length}) }}</span>
                    </slot>

                    <div class="people">
                        <div
                            v-for="person in selection"
                            :key="person.id"
                            class="person phi-media"
                        >
                            <div class="phi-media-figure phi-avatar">
                                <phi-person-avatar
                                    :name="getPersonFullName(person)"
                                    :id="person.id"
                                    :image="person.avatar"
                                ></phi-person-avatar>
                            </div>
                            <div class="phi-media-body" v-html="getPersonFullName(person)"></div>
                            <mu-icon value="cancel" class="phi-media-right" @click.stop="selection.splice(selection.indexOf(person), 1)"></mu-icon>
                        </div>
                        <div class="adder phi-media">
                            <mu-icon class="phi-media-figure" value="add"></mu-icon>
                        </div>
                    </div>

                </div>
            </slot>

        </div>

        <phi-slider-panel
            side="right"
            :open="template.panelIsOpen"
            size="85vw"
            @closed="template.panelIsOpen = false; template.boxIsFlipped = false; clearSearch();"
        >
            <div class="phi-person-relevance-picker-box" :class="{flipped: template.boxIsFlipped}">

                <!-- FRENTE de la caja: Listado de grupos -->
                <div class="front">

                    <div v-if="completedRequest" class="toolbar sticky">
                        <mu-icon class="back" value="close" @click="template.panelIsOpen = false"></mu-icon>
                        <div class="search main">
                            <mu-icon value="close" v-if="peopleQuery.length > 0" @click="peopleQuery = ''"></mu-icon>
                            <mu-icon value="search" v-else></mu-icon>
                            <input type="text" v-model="peopleQuery" :placeholder="$t('search')" @input="dSearch()" />
                        </div>
                        <div class="counter">{{ selection.length }}</div>
                    </div>
                    <div v-else class="toolbar">
                        <div class="meter">
                            <span v-bind:style="{ width: reuqestProgress + '%' }"></span>
                        </div>
                    </div>

                    <div class="people-list small-list">
                        <div class="people">
                            <div
                                v-for="person in reverseSelection"
                                :key="person.id"
                                class="person phi-media"
                                @click="togglePicker"
                            >
                                <div class="phi-media-figure phi-avatar">
                                    <phi-person-avatar
                                        :name="getPersonFullName(person)"
                                        :id="person.id"
                                        :image="person.avatar"
                                    ></phi-person-avatar>
                                </div>
                                <div class="phi-media-body" v-html="getPersonFullName(person)"></div>
                                <mu-icon value="cancel" class="phi-media-right" @click.stop="selection.splice(selection.indexOf(person), 1)"></mu-icon>
                            </div>
                        </div>
                    </div>

                    <!-- listado de grupos -->
                    <section class="group-list">
                        <div v-if="peopleQuery.length > 0">
                            <div class="people">
                                <div
                                    v-for="person in orderedPeopleFound"
                                    :key="person.id"
                                    class="person phi-media"
                                    @click="togglePerson(person)"
                                    :class="{ selected: isSelected(person) }"
                                >
                                    <div class="phi-media-figure phi-avatar">
                                        <phi-person-avatar
                                            :name="getPersonFullName(person)"
                                            :id="person.id"
                                            :image="person.avatar"
                                            :selected="isSelected(person)"
                                        ></phi-person-avatar>
                                    </div>
                                    <div class="phi-media-body">
                                        <h1 v-phi-highlight="person.matches" v-html="getPersonFullName(person)"></h1>
                                        <span class="roles" v-for="(role, key) in person.roles" :key="key">{{ $t(role) }}<span v-if="key < person.roles.length-1">, </span></span>
                                    </div>
                                </div>
                            </div>

                            <div class="groups">
                                <div
                                    v-for="group in orderedGroupsFound"
                                    :key="group.id"
                                    class="group"
                                >
                                    <div class="header phi-media" @click="openGroup(group)">
                                        <h1 v-phi-highlight="group.matches" class="phi-media-body">{{ group.name }}</h1>
                                        <mu-icon class="phi-media-right" value="chevron_right"></mu-icon>
                                    </div>
                                </div>
                            </div>

                            <div class="person phi-media" v-if="peopleFound.length+groupsFound.length <= 0 && peopleQuery.length > 1" @click="peopleQuery = ''">
                                <div>
                                    <div class="phi-media-figure phi-avatar">
                                        <mu-icon value="sentiment_dissatisfied" :size="36"/>
                                    </div>
                                    <div class="phi-media-body">
                                        <h1>{{ $t("I did not find anyone") }}</h1>
                                        <span class="roles">{{ $t("try again") }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            v-for="group in groups"
                            :key="group.id"
                            :class="{group: true, relatives: group.type == 'relatives', empty: group.people.length <= 0, nomembers: !groupHasMembers(group)}"
                            v-if="peopleQuery.length <= 0"
                        >
                            <div class="header phi-media" @click="openGroup(group);">
                                <h1 class="phi-media-body">{{ group.name }}</h1>
                                <mu-icon class="phi-media-right" value="chevron_right"></mu-icon>
                            </div>

                            <div class="people">
                                <div
                                    v-for="person in group.people"
                                    :key="person.id"
                                    class="person phi-media"
                                    @click="togglePerson(person)"
                                    :class="{ selected: isSelected(person) }"
                                    v-if="person.id != personId"
                                >
                                    <div class="phi-media-figure phi-avatar">
                                        <phi-person-avatar
                                            :name="getPersonFullName(person)"
                                            :id="person.id"
                                            :image="person.avatar"
                                            :selected="isSelected(person)"
                                        ></phi-person-avatar>
                                    </div>
                                    <div class="phi-media-body">
                                        <h1 v-html="getPersonFullName(person)"></h1>
                                        <span class="roles" v-for="(role, key) in person.roles" :key="key">{{ $t(role) }}<span v-if="key < person.roles.length-1">, </span></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>


                <div class="back">
                    <div v-if="activeGroup">

                        <div class="sticky">
                            <div class="toolbar">
                                <mu-icon class="back" value="chevron_left" @click="closeGroup()"></mu-icon>
                                <div class="main">{{ activeGroup.name }}</div>
                                <div class="counter">{{ selection.length }}</div>

                                <!-- seleccion de roles -->
                                <div class="phi-tooltip">
                                    <mu-icon value="more_vert"></mu-icon>
                                    <ul class="phi-menu phi-card">
                                        <li @click="activeGroup.members.forEach(selectPerson); getRelatives(activeGroup.members).forEach(selectPerson);">{{ $t("everyone")}}</li>
                                        <li @click="activeGroup.members.forEach(deselectPerson); getRelatives(activeGroup.members).forEach(deselectPerson);">{{ $t("noone")}}</li>
                                        <li v-for="role in distinctRoles(activeGroup)" @click="toggleWithRole(activeGroup.members, role)" :class="{checked: roleIsSelected(activeGroup.members, role)}">
                                            {{ $t(role) }}
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div v-if="completedRequest" class="toolbar subtoolbar">
                                <div class="search main">
                                    <mu-icon value="close" v-if="peopleQuery.length > 0" @click="peopleQuery = ''"></mu-icon>
                                    <mu-icon value="search" v-else></mu-icon>
                                    <input type="text" v-model="peopleQuery" :placeholder="$t('search')" @input="dSearch()" />
                                </div>
                            </div>
                        </div>

                        <div class="people-list small-list">
                            <div class="people">
                                <div
                                    v-for="person in reverseSelection"
                                    :key="person.id"
                                    class="person phi-media"
                                    @click="togglePicker"
                                >
                                    <div class="phi-media-figure phi-avatar">
                                        <phi-person-avatar
                                            :name="getPersonFullName(person)"
                                            :id="person.id"
                                            :image="person.avatar"
                                        ></phi-person-avatar>
                                    </div>
                                    <div class="phi-media-body" v-html="getPersonFullName(person)"></div>
                                    <mu-icon value="cancel" class="phi-media-right" @click.stop="selection.splice(selection.indexOf(person), 1)"></mu-icon>
                                </div>
                            </div>
                        </div>

                        <!-- listado de personas en el grupo activo -->
                        <section class="group-list">

                            <div v-if="peopleQuery.length > 0">
                                <div class="people">
                                    <div
                                        v-for="person in orderedPeopleFound"
                                        :key="person.id"
                                        class="person phi-media"
                                        @click="togglePerson(person)"
                                        :class="{ selected: isSelected(person) }"
                                    >
                                        <div class="phi-media-figure phi-avatar">
                                            <phi-person-avatar
                                                :name="getPersonFullName(person)"
                                                :id="person.id"
                                                :image="person.avatar"
                                                :selected="isSelected(person)"
                                            ></phi-person-avatar>
                                        </div>
                                        <div class="phi-media-body">
                                            <h1 v-phi-highlight="person.matches" v-html="getPersonFullName(person)"></h1>
                                            <span class="roles" v-for="(role, key) in person.roles" :key="key">{{ $t(role) }}<span v-if="key < person.roles.length-1">, </span></span>
                                        </div>
                                    </div>
                                </div>

                                <div class="person phi-media" v-if="peopleFound.length+groupsFound.length <= 0 && peopleQuery.length > 1" @click="peopleQuery = ''">
                                    <div>
                                        <div class="phi-media-figure phi-avatar">
                                            <mu-icon value="sentiment_dissatisfied" :size="36"/>
                                        </div>
                                        <div class="phi-media-body">
                                            <h1>{{ $t("I did not find anyone") }}</h1>
                                            <span class="roles">{{ $t("try again") }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                v-for="person in activeGroup.members"
                                class="person container"
                                :class="{ selected: isSelected(person) }"
                                v-if="peopleQuery.length <= 0"
                            >
                                <div class="phi-media"
                                    v-if="person.id && person.id != personId"
                                    @click="togglePerson(person)"
                                >
                                    <div class="phi-media-figure phi-avatar">
                                        <phi-person-avatar
                                            :name="getPersonFullName(person)"
                                            :id="person.id"
                                            :image="person.avatar"
                                            :selected="isSelected(person)"
                                        ></phi-person-avatar>
                                    </div>
                                    <div class="phi-media-body">
                                        <h1 v-html="getPersonFullName(person)"></h1>
                                        <span class="roles" v-for="(role, key) in person.roles">{{ $t(role) }}<span v-if="key < person.roles.length-1">, </span></span>
                                    </div>
                                </div>

                                <!-- relatives -->
                                <div class="relatives">
                                    <div class="person phi-media"
                                        v-for="relative in person.relatives"
                                        :key="relative.id"
                                        @click="togglePerson(relative)"
                                        :class="{ selected: isSelected(relative) }"
                                    >
                                        <div class="phi-media-figure phi-avatar">
                                            <phi-person-avatar
                                                :name="getPersonFullName(relative)"
                                                :id="relative.id"
                                                :image="relative.avatar"
                                                :selected="isSelected(relative)"
                                            ></phi-person-avatar>
                                        </div>
                                        <div class="phi-media-body">
                                            <h1 v-html="getPersonFullName(relative)"></h1>
                                            <span class="roles" v-for="(role, key) in relative.roles" :key="key">{{ $t(role) }}<span v-if="key < relative.roles.length-1">, </span></span>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </section>
                    </div>
                </div>

            </div>
        </phi-slider-panel>
    </div>
</template>

<style lang="scss">
.phi-person-relevance-picker-box {

    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    overflow-y: auto;
    background-color: #fff;

    mark {
        color: #1C89B8;
        background-color: rgba(0,0,0,0);
    }

    @media (min-width: 500px) {
        .group-list, .group-list div div.people, .group-list div div.groups{
            display: flex;
            flex-wrap: wrap;

            .group, .person{
                flex-basis: 370px;
            }
        }
    }

    & > .front,
    & > .back {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        overflow: hidden;
        overflow-y: auto;

        transition: 0.5s;

        section.group-list div.person.container{
            margin-bottom: 10px;

            .relatives{
                padding: 0;

                .phi-media {
                    padding: 7px;
                    margin-left: 24px;

                    .phi-avatar{
                        height: 32px;
                        width: 32px;
                        min-width: 32px;
                        max-width: 32px;
                        min-height: 32px;
                        max-height: 32px;
                    }
                }
            }
        }
    }

    & > .front {
        transform: translateX(0);
    }

    & > .back {
        transform: translateX(100%);
    }

    &.flipped {
        & > .front {
            transform: translateX(-100%);
        }
        & > .back {
            transform: translateX(0);
        }
    }

    .toolbar {
        display: flex;
        align-items: center;

        .back {
            padding: 8px 12px;
            color: #666;
            cursor: pointer;
        }

        .loading {
            padding: 8px 12px;
            color: #666;
        }

        .main {
            flex: 1;
        }

        .notice{
            color: #666;
            font-size: .9em;
        }

        .search {
            display: flex;
            align-items: center;
            border-bottom: 1px solid #ccc;

            input {
                flex: 1;
                border: none;
                background: transparent;
                padding: 4px;
                @media (min-width: 500px) {
                    font-size: 1em;
                }
            }

            .mu-icon {
                color: #999;
                cursor: pointer;
                font-size: 14px;
            }
        }

        .counter {
            padding: 8px 12px;
            font-size: 12px;
            font-weight: bold;
            color: #1C89B8;
        }

        .phi-tooltip {
            .mu-icon {
                padding: 8px 12px;
                color: #777;
            }
        }

        &.subtoolbar {
            padding: 8px;
        }

        .meter{
            width: 100%;
            height: 40px;
            overflow: hidden;

            span{
                display: block;
                height: 5px;
                background-color: #1C89B8;
                overflow: hidden;
                position: relative;
            }

            span:after{
                content: '';
                opacity: 0;
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                background: #fff;
                animation: animate-shine 2s ease-out infinite;
            }
        }
    }

    div.sticky
    {
        position: -webkit-sticky; /* Safari */
        position: sticky;
        top: 0;
        z-index: 1000;
        padding: 8px 20px;
        background: #F2F2F2;
    }

    @keyframes animate-shine {
        0% {opacity: 0; width: 0;}
        50% {opacity: .5;}
        100% {opacity: 0; width: 100%;}
    }

    .person {
        align-items: center;
        cursor: pointer;

        @media (min-width: 500px) {
            margin: 5px;
        }

        h1 {
            font-size: 1em;
            font-weight: normal;
        }

        .roles {
            font-size: .8em;
            color: #777;
        }

        .phi-media-right {
            color: #1C89B8;
        }

        &.selected {
            background-color: #edf4fd;
        }

        &:hover {
            background-color: rgba(0, 0, 0, .04);
        }
    }

    .group {
        .header {
            @media (min-width: 500px) {
                background-color: rgba(0, 0, 0, .04);
                border-radius: 4px;
                margin: 14px 0 0 14px;

                &:hover {
                   color: #1C89B8;
                }
            }

            cursor: pointer;
            &:hover {
                background-color: rgba(0, 0, 0, .04);
            }

            h1 {
                font-size: 1.1em;
                font-weight: normal;
            }
        }

        .people {
            padding-left: 18px;

            @media (min-width: 500px) {
                margin: 5px;
            }
        }


        &.relatives {
            .header {
                display: none;
            }

            .people {
                padding: 0;

                .phi-media {
                    padding: 7px;
                    margin-left: 24px;

                    .phi-avatar{
                        height: 32px;
                        width: 32px;
                        min-width: 32px;
                        max-width: 32px;
                        min-height: 32px;
                        max-height: 32px;
                    }
                }
            }
        }
    }

    .group.relatives.empty{
        visibility: hidden;
        display: none
    }

    .group.nomembers{
        .header{
            @media (min-width: 500px) {
                &:hover {
                   color: #444;
                }
            }

            cursor: auto;

            .mu-icon{
                visibility: hidden;
                display: none
            }
        }
    }
}

.phi-person-relevance-picker {

}

.people-list {
    .people {
        display: flex;
        flex-wrap: wrap;
        align-items: center;

        @media (max-width: 500px) {
            display: block;

            .person,
            .adder {
                margin: 0.2em 0 !important;
            }
        }

        .adder,
        .person {
            margin: 0.2em;
            min-height: 40px;
            border-radius: 4px;
            background-color: #f4f4f4;
            align-items: center;
            padding: 4px;
        }

        .adder {
            cursor: pointer;
            color: #666;

            .phi-media-figure {
                margin: 0;
                text-align: center;
            }
        }

        .person {
            min-width: 210px;

            .phi-media-figure {
                width: 32px !important;
                height: 32px !important;
                min-width: 32px !important;
                min-height: 32px !important;

                margin: 0;
            }

            .phi-media-body {
                padding: 0 8px;
                h1 {
                    font-weight: 300;
                }
            }

            .phi-media-right {
                cursor: pointer;
                font-weight: bold;
                color: #999;
            }

            .phi-media-right:hover {
                color: darkred;
            }
        }

    }

}

.small-list{
    max-height: 141px;
    overflow-y: scroll;
    background-color: rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    margin-bottom: 2px;
    padding: 4px 16px;
    font-size: 0.9em;
}
</style>